import {useSelector} from 'react-redux';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import {Button, Form, Message, Segment} from 'semantic-ui-react';
import FormInput from '../../shared/forms/input';
import {mobile, required} from '../../shared/forms';

function UpdateMobileForm(props) {
  const {handleSubmit, pristine, submitting, error} = props;
  const prevMobile = useSelector(({user}) => user.data.mobile);

  async function submit({mobile}) {
    if (mobile === prevMobile)
      throw new SubmissionError({mobile: 'شماره انتخاب شده نمی‌تواند با شماره کنونی یکی باشد.'});

    try {
      await props.onSubmit(mobile);
    } catch (error) {
      if (error.data && error.data.hasOwnProperty('mobile')) {
        throw new SubmissionError({mobile: error.data.mobile});
      } else if (error.status === 403) {
        const errorMessage = error.data.detail || 'محدودیت ارسال کد تایید شما به پایان رسیده است،';
        props.onError(errorMessage);
      } else {
        const errorMessage = error.data.detail || error.data || 'تغییر شماره تلفن همراه انجام نشد.';
        throw new SubmissionError({_error: errorMessage});
      }
    }
  }

  return (
    <Segment>
      {/*form error*/}
      {(error && !pristine) && (
        <Message
          error
          header={error}
          className={'text-center'}
        />
      )}

      {/*form*/}
      <Form onSubmit={handleSubmit(submit.bind(null))}>
        <Field
          required
          name='mobile'
          label='تلفن همراه'
          type='tel'
          component={FormInput}
          validate={[required, mobile]}
        />
        <Button
          type='submit'
          disabled={pristine || submitting}
          content='تغییر شماره تلفن همراه'
        />
      </Form>
    </Segment>
  );
}

export default reduxForm({form: 'update-mobile'})(UpdateMobileForm);
